import { render, staticRenderFns } from "./list-upload-reports.vue?vue&type=template&id=5b1b1d4f&scoped=true"
import script from "./list-upload-reports.vue?vue&type=script&lang=js"
export * from "./list-upload-reports.vue?vue&type=script&lang=js"
import style0 from "./list-upload-reports.vue?vue&type=style&index=0&id=5b1b1d4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b1d4f",
  null
  
)

export default component.exports